module.exports = __webpack_public_path__ + "static/media/ny.0ab2b9a8.svg";